import { render } from "./Redeem.vue?vue&type=template&id=8c91f1fc&scoped=true"
import script from "./Redeem.vue?vue&type=script&lang=js"
export * from "./Redeem.vue?vue&type=script&lang=js"

import "./Redeem.vue?vue&type=style&index=0&id=8c91f1fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c91f1fc"]])

export default __exports__